import { useTranslation } from "react-i18next";
import { ValidationError } from "../../types/forms/ValidationResult";
import DangerAlert from "../alerts/DangerAlert";
import formValidationHelper from "../../helpers/formValidationHelper";

interface ValidationWarningProps {
  isValid: boolean;
  errors: Array<ValidationError> | null;
}

export const ValidationErrorClassName = "validation-error";

function ValidationWarning({ isValid, errors }: ValidationWarningProps) {
  const { t } = useTranslation();
  if (isValid) return null;
  const warningPrefix = t("Common.Validation.Oops");

  const getErrorMessage = (error: ValidationError): string => {
    return error.customMessage || formValidationHelper.getMessageText(error);
  };

  return (
    <>
      {(!errors || errors.length === 0) && (
        <DangerAlert
          prefix={warningPrefix}
          message={t("Common.Validation.Errors.Unknown")}
          extraClassNames={ValidationErrorClassName}
        />
      )}
      {errors && errors.length === 1 && (
        <DangerAlert
          prefix={warningPrefix}
          message={getErrorMessage(errors[0])}
          extraClassNames={ValidationErrorClassName}
        />
      )}
      {errors && errors.length > 1 && (
        <>
          <DangerAlert
            prefix={warningPrefix}
            message={t("Common.Validation.Errors.Multiple")}
            extraClassNames={ValidationErrorClassName}
          />
          <ul>
            {errors.map((err, ix) => (
              <li key={`err_${ix}`}>{getErrorMessage(err)}</li>
            ))}
          </ul>
        </>
      )}
    </>
  );
}

export default ValidationWarning;
